<div class="{{localService.selectedLanguageCode}}"
  *ngIf="localService.languageContent && localService.languageContent.pay_from_wallet && details">
  <app-popup-header title="{{localService.languageContent.pay_from_wallet.header}}" (onRefresh)="onLoad()"
    [isRefresh]="true"></app-popup-header>
  <div class="modal-body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
    <div *ngIf="details.v12 == '0'">
      <div>
        {{localService.languageContent.pay_from_wallet.upi_need}}
      </div>
      <div class="row" *ngIf="isElligibleToAddUpiDetail">
        <div class="col-3">
          <app-label [Text]="localService.languageContent.common.upi"></app-label>
        </div>
        <div class="col-9">
          <input autocomplete="off" id="{{elementIds.business_upi}}" [ngClass]="upi != '' ? 'en' : ''" type="text"
            [(ngModel)]="upi" placeholder="{{localService.languageContent.common.upi}}"
            title="{{localService.languageContent.common.upi}}" />
        </div>
      </div>
    </div>
    <div *ngIf="details.v12 == '1' && (customerId == '' && customerIdBusiness == '' && paidDate == '')">
      {{localService.languageContent.pay_from_wallet.customer_required}}
    </div>
    <div *ngIf="details.v12 == '1' && !(customerId == '' && customerIdBusiness == '' && paidDate == '')">
      <div class="row">
        <div class="col-6" style="text-align:right;">
          <app-label [Text]="localService.languageContent.pay_from_wallet.required_amount" [IsColonRequired]="true"
            [IsMandatory]="true"></app-label>
        </div>
        <div class="col-6">
          <span class="en">{{details.v1 | number: '1.2-2'}}</span>
        </div>
      </div>
      <div class="row" *ngIf="paidDate != ''">
        <div class="col-6" style="text-align:right;">
          <app-label [Text]="localService.languageContent.pay_from_wallet.paid_on"></app-label>
        </div>
        <div class="col-6">
          <span class="en">{{details.v2 | localDate}}</span>
        </div>
      </div>
      <div *ngIf="paidDate == ''">
        <div class="row" *ngIf="customerIdBusiness != ''">
          <div class="col-12">
            <br />
            <div>
              <label style="margin-left:15px;font-weight:normal;">
                <input autocomplete="off" id="{{elementIds.business_customer_pay}}" type="radio" name="customerType"
                  (click)="onCustomerSelected('1')"
                  [checked]="isCustomerSelected != undefined && isCustomerSelected != null && isCustomerSelected == false">
                <span>
                  {{localService.languageContent.pay_from_wallet.business_account}}&nbsp;(<span
                    [ngClass]="localService.getLanguageCode(details.v8)">{{details.v9}}</span>)
                </span>
              </label>
            </div>
            <div class="row">
              <div class="col-1">
                &nbsp;
              </div>
              <div class="col-11">
                <app-label [Text]="localService.languageContent.pay_from_wallet.is_required_amount_available"
                  [IsColonRequired]="true" [IsMandatory]="true"></app-label>
                <span>{{details.v10 == '1' ? localService.languageContent.common.yes :
                  localService.languageContent.common.no}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="customerId != ''">
          <div class="col-12">
            <br />
            <div>
              <label style="margin-left:15px;font-weight:normal;">
                <input autocomplete="off" id="{{elementIds.customer_pay}}" type="radio" name="customerType"
                  (click)="onCustomerSelected('2')"
                  [checked]="isCustomerSelected != undefined && isCustomerSelected != null && isCustomerSelected == true">
                <span>
                  {{localService.languageContent.pay_from_wallet.individual_account}}&nbsp;(<span
                    [ngClass]="localService.getLanguageCode(details.v4)">{{details.v5}}</span>)
                </span>
              </label>
            </div>
            <div class="row">
              <div class="col-1">
                &nbsp;
              </div>
              <div class="col-11">
                <app-label [Text]="localService.languageContent.pay_from_wallet.is_required_amount_available"
                  [IsColonRequired]="true" [IsMandatory]="true"></app-label>
                <span>{{details.v6 == '1' ? localService.languageContent.common.yes :
                  localService.languageContent.common.no}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer"
    *ngIf="details.v12 == '0' || (!(customerId == '' && customerIdBusiness == '') && paidDate == '')">
    <app-otp-container [PhNumOrEmail]="details.v11" [businessId]="isCustomerSelected ? '' : details.v7"
      [interactionType]="2" (onVerified)="onVerifiedOtpVerified($event)" [otpType]="8"
      *ngIf="isShowOtpVerification"></app-otp-container>
    <div class="row" style="width:100%" *ngIf="!isShowOtpVerification">
      <div class="col-6" style="text-align:left;">
        <button type="button" *ngIf="businessOrUserId != ''" class="btn btn-primary"
          (click)="onShowPayment()">{{localService.languageContent.pay_from_wallet.add_money}}</button>
      </div>
      <div class="col-6" style="text-align:right;">
        <button type="button" class="btn btn-primary"
          *ngIf="details.v12 == '1' || (details.v12 == '0' && isElligibleToAddUpiDetail)"
          [disabled]="businessOrUserId != ''" (click)="onPopupSave()">{{details.v12 == '1' ?
          localService.languageContent.pay_from_wallet.pay : localService.languageContent.common.save}}</button>
      </div>
    </div>
  </div>
</div>
<app-payments [(isShowPayment)]="isShowPayment" [amount]="amount" [paidType]="3" [businessOrUserId]="businessOrUserId"
  [interactionType]="interactionTypePayment" (onPaymentProccesed)="onPaymentProccesed($event)"></app-payments>